import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'

const noImage = '<img src="/static/webapp/icons/unknown.svg">'

const BASE_DOMAIN = window.IS_STORYBOOK ? 'https://members.ironstaging.ironscales.com' : ''
const MAP_PATHS_BY_TYPE = {
  stroke: (imageName) => `${BASE_DOMAIN}/static/webapp/icons/${imageName}.svg`,
  fill: (imageName) => `${BASE_DOMAIN}/static/webapp/icons/fill/${imageName}.svg`,
}
const Icon = ({ id, className, testId, onClick, imageName, title, fillType = 'stroke' }) => {
  const [data, setData] = useState(null)

  let cleanupFunction = false

  const fetchMyAPI = useCallback(async () => {
    const url = MAP_PATHS_BY_TYPE[fillType](imageName)
    let layoutImage

    try {
      let response = await fetch(url)

      if (response.status !== 200) {
        layoutImage = noImage
      } else {
        response = await response.text()
        layoutImage = response
      }
    } catch (e) {
      layoutImage = noImage
    }

    if (!cleanupFunction) setData(layoutImage)
  }, [imageName])

  const createMarkup = (str) => ({
    __html: str,
  })

  useEffect(() => {
    fetchMyAPI()

    return () => (cleanupFunction = true)
  }, [fetchMyAPI])

  return (
    <span
      id={id}
      data-testid={testId}
      className={className}
      onClick={onClick}
      dangerouslySetInnerHTML={createMarkup(data)}
      title={title}
    />
  )
}

/**
 * @deprecated please use DesignSystem/Icons instead.
 */

export default styled(Icon)`
  display: inline-flex;
  align-items: center;

  &:hover {
    cursor: ${function (props) {
      return props.onClick || props.hoverFill ? 'pointer' : 'unset'
    }};
    svg,
    svg > path {
      fill: ${(props) => (props.hoverFill ? props.hoverFill : props.fill)};
    }
  }

  svg,
  svg > path {
    height: ${(props) => props.size || props.height} !important;
    fill: ${(props) => props.fill || 'currentColor'};
    // need to remove table design, icons get affected by css on svg
    width: ${(props) => props.size || props.width} !important;

    &:hover {
      fill: ${(props) => (props.hoverFill ? props.hoverFill : props.fill)};
    }
  }
`
